const Icon = (props: any) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    stroke="white"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5127 2.5H6.5127C5.98226 2.5 5.47355 2.71071 5.09848 3.08579C4.72341 3.46086 4.5127 3.96957 4.5127 4.5V20.5C4.5127 21.0304 4.72341 21.5391 5.09848 21.9142C5.47355 22.2893 5.98226 22.5 6.5127 22.5H18.5127C19.0431 22.5 19.5518 22.2893 19.9269 21.9142C20.302 21.5391 20.5127 21.0304 20.5127 20.5V8.5M14.5127 2.5L20.5127 8.5M14.5127 2.5V8.5H20.5127M16.5127 13.5H8.5127M16.5127 17.5H8.5127M10.5127 9.5H8.5127"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon;
